export default __webpack_public_path__ + "static/media/8.e80c2b4c.jpeg";